<template>

    <div class="parentx-static">

        <vs-sidebar
            ref="mainSidebar"
            v-model="isSidebarActive"
            color="primary"
            class="sidebarx main-menu-sidebar items-no-padding"
            parent=".layout--main"
            :hidden-background="true"
            :reduce="false"
            :default-index="currentIndex"
            :click-not-close="false"
            :reduce-not-rebound="false"
            :reduce-not-hover-expand="true"
        >

            <!-- Logo -->
            <div class="header-sidebar" slot="header">
                <div class="logo flex items-center">
                <img class="main-logo-image" :src="'/assets/images/'+menuLogo+'-icon.png'" height="32px" />
                <img class="main-logo-image truncate" :src="'/assets/images/'+menuLogo+'-text.png'" height="32px" />
                </div>
            </div>

            <div class="scroll-container">
                <div class="shadow-bottom"></div>
                <div class="scroll-area--main-sidebar" ref="sideBar">

                    <vs-sidebar-item href="/rh" ref="sidebarLink" index="/rh" title="Accueil">
                        <feather-icon icon="HomeIcon" class="" />
                        <span class="truncate">Accueil</span>
                    </vs-sidebar-item>

                    <!-- GESTION -->
                    <span class="navigation-header truncate">Espace Utilisateur</span>

                    <vs-sidebar-item v-if="planAllow('campaigns', null, false)" href="/rh/gestion/campaigns" ref="sidebarLink" index="/rh/gestion/campaigns" title="Campagnes">
                        <feather-icon icon="CheckSquareIcon" class="" />
                        <span class="truncate">Campagnes</span>
                    </vs-sidebar-item>

                    <!-- TODO - Compte portail -->
                    <vs-sidebar-item v-if="planAllow('projet_pro_from_evalautions') && can('read', 'employees')" href="/rh/gestion/personnes" ref="sidebarLink" index="/rh/gestion/personnes" title="Personnes">
                        <feather-icon icon="UsersIcon" class="" />
                        <span class="truncate">Personnes</span>
                    </vs-sidebar-item>

                    <vs-sidebar-item v-if="planAllow('projet_pro_from_evalautions') && can('read', 'employee_ratings')" href="/rh/gestion/bilans" ref="sidebarLink" index="/rh/gestion/bilans" :title="projectNames.plural">
                        <feather-icon icon="CheckSquareIcon" class="" />
                        <span class="truncate">Evaluations</span>
                    </vs-sidebar-item>

                    <app-menu-group 
                        v-if="(isASuperAdmin() || isAnAdmin() || isADrh() || isAMonitor()) && planAllow('suivis')"
                        icon="PenToolIcon" 
                        name="Suivis" 
                        base-index="/rh/gestion/suivis*" 
                        title="Suivi"
                        required-plan="suivis"
                    >
                        <item
                            href="/rh/gestion/suivis/objectifs" 
                            icon="TrendingUpIcon" 
                            label="Objectifs" 
                            title="Suivi des objectifs" 
                            required-plan="suivi-objectifs"
                        />
                        <item
                            href="/rh/gestion/parcours"
                            icon="AlignRightIcon"
                            label="Parcours"
                            title="Suivi des parcours"
                            required-plan="parcours_graphique"
                        />
                        <item
                            v-if="planAllow('campaigns', null, false)"
                            href="/rh/gestion/suivis/actions"
                            icon="TrendingUpIcon"
                            label="PDCA"
                            title="PDCA"
                            required-plan="suivi-actions"
                        />
                    </app-menu-group>

                    <app-menu-group
                        v-if="(isASuperAdmin() || isAnAdmin() || isADrh() || isAMonitor()) && planAllow('dashbords')"
                        icon="PieChartIcon" 
                        name="Tableau de bord" 
                        base-index="/rh/gestion/tableaux*" 
                        title="Tableau de bord"
                        required-plan="dashbords"
                    >
                        <item
                            href="/rh/gestion/tableaux/personnes" 
                            icon="UserIcon" 
                            label="Personnes" 
                            title="Tableau de bord - Personnes" 
                            required-plan="dashbords_persons"
                        />
                        <item
                            href="/rh/gestion/tableaux/metiers-postes" 
                            icon="BookmarkIcon" 
                            label="Métiers / postes" 
                            title="Tableau de bord - Métiers / poste" 
                            required-plan="dashbords_occupations_jobs"
                        />
                        <item
                            href="/rh/gestion/tableaux/competences" 
                            icon="BoxIcon" 
                            label="Compétences" 
                            title="Tableau de bord - Compétences" 
                            required-plan="dashbords_skills"
                        />
                        <item
                            href="/rh/gestion/tableaux/savoir-faire" 
                            icon="ApertureIcon" 
                            label="Savoir-faire" 
                            title="Tableau de bord - Savoir-faire" 
                            required-plan="dashbords_occupationskills"
                        />
                    </app-menu-group>

                    <!-- REFERENTIEL -->
                    <span class="navigation-header truncate">Administration</span>

                    <vs-sidebar-item v-if="can('read', 'users')" href="/rh/referentiel/utilisateurs" ref="sidebarLink" index="/rh/referentiel/utilisateurs" title="Utilisateurs">
                        <feather-icon icon="UsersIcon" class="" />
                        <span class="truncate">Utilisateurs</span>
                    </vs-sidebar-item>

                    <app-menu-group
                        icon="ListIcon"
                        name="Référentiel"
                        base-index="/rh/referentiel*"
                        title="Référentiel"
                    >
                        <item
                            v-if="isAbleTo('read-campaigns', undefined, user) && planAllow('campaigns', null, false)"
                            href="/rh/referentiel/questions"
                            icon="TagIcon"
                            label="Questions"
                            title="Référentiel - Questions"
                        />

                        <item
                            v-if="isAbleTo('read-blocs', undefined, user) && planAllow('campaigns', null, false)"
                            href="/rh/referentiel/blocs"
                            icon="GridIcon"
                            label="Blocs"
                            title="Référentiel - Blocs"
                        />
                        
                        <item
                            v-if="isAbleTo('read-skills', undefined, user)"
                            href="/rh/referentiel/competences"
                            icon="AwardIcon"
                            label="Compétences"
                            title="Référentiel - Compétences"
                        />

                        <item
                            v-if="isAbleTo('read-occupation_skills', undefined, user)"
                            href="/rh/referentiel/savoir-faire"
                            icon="ApertureIcon"
                            label="Savoir-faire"
                            title="Référentiel - Savoir-faire"
                        />

                        <item
                            v-if="isAbleTo('read-jobs', undefined, user)"
                            href="/rh/referentiel/postes"
                            icon="ClipboardIcon"
                            label="Postes/stages"
                            title="Référentiel - Postes"
                        />

                        <item
                            v-if="isAbleTo('read-grids', undefined, user)"
                            href="/rh/referentiel/grilles"
                            icon="GridIcon"
                            label="Grilles"
                            title="Référentiel - Grilles"
                        />

                        <item
                            v-if="isAbleTo('read-occupations', undefined, user)"
                            href="/rh/referentiel/metiers"
                            icon="TargetIcon"
                            label="Métiers"
                            title="Référentiel - Métiers"
                        />

                        <item
                            v-if="isASuperAdmin() || isAnAdmin()"
                            href="/rh/referentiel/catalogues"
                            icon="BookOpenIcon"
                            label="Parcours"
                            title="Référentiel - Parcours"
                        />

                        <item
                            v-if="isAbleTo('read-services', undefined, user)"
                            href="/rh/referentiel/services"
                            icon="LayersIcon"
                            label="Services"
                            title="Référentiel - Services"
                        />

                        <item
                            v-if="isAbleTo('read-establishments', undefined, user)"
                            href="/rh/referentiel/etablissements"
                            icon="GridIcon"
                            label="Établissements"
                            title="Référentiel - Établissements"
                        />   

                    </app-menu-group>

                    <vs-sidebar-item v-if="isASuperAdmin()" href="/laratrust" ref="sidebarLink" index="/rh/referentiel/laratrust" title="Rôles & Permissions">
                        <feather-icon icon="UnlockIcon" class="" />
                        <span class="truncate">Rôles & Permissions</span>
                    </vs-sidebar-item>

                    <vs-sidebar-item v-if="isASuperAdmin()" href="#" data-href="/rh/referentiel/alertes" ref="sidebarLink" index="/rh/referentiel/alertes" style="opacity: 0.5" title="Message d'informations">
                        <feather-icon icon="InfoIcon" class="" />
                        <span class="truncate">Message d'informations</span>
                    </vs-sidebar-item>

                    <app-menu-group
                        v-if="(isASuperAdmin() || isAnAdmin() || isADrh() || isAMonitor()) && planAllow('indicateurs-activite')"
                        icon="TrelloIcon"
                        name="Statistiques"
                        base-index="/rh/referentiel*"
                        title="Statistiques"
                        required-plan="indicateurs-activite"
                    >
                        <item
                            href="/rh/referentiel/statistiques"
                            icon="PercentIcon"
                            label="Suivi d'activité"
                            title="Statistiques - Suivi d'activité"
                            required-plan="indicateurs-activite"
                        />
                        <item
                            href="/rh/referentiel/usages"
                            icon="ActivityIcon"
                            label="Suivi des usages"
                            title="Statistiques - Suivi des usages"
                            required-plan="indicateurs-activite"
                        />
                    </app-menu-group>

                    <app-menu-group
                        v-if="isASuperAdmin() || isAnAdmin() && planAllow('params')"
                        icon="SettingsIcon"
                        name="Paramètres"
                        base-index="/rh/referentiel/parametres*"
                        title="Paramètres"
                        required-plan="params"
                    >
                        <item 
                            v-if="isASuperAdmin()" 
                            href="/rh/referentiel/parametres/parcours" 
                            icon="AlignRightIcon" 
                            label="Parcours" 
                            title="Paramètres - Parcours"
                            required-plan="params_parcours"
                        />
                        <item 
                            v-if="isASuperAdmin()" 
                            href="/rh/referentiel/parametres/notation" 
                            icon="TagIcon" 
                            label="Notation" 
                            title="Paramètres - Notation"
                            required-plan="params_notations"
                        />
                        <item 
                            v-if="isASuperAdmin()" 
                            href="/rh/referentiel/parametres/bilans" 
                            icon="CheckSquareIcon" 
                            label="Evaluations" 
                            title="Paramètres - Evaluations"
                            required-plan="params_evaluations"
                        />
                        <item 
                            v-if="isASuperAdmin() || isAnAdmin()" 
                            href="/rh/referentiel/parametres/images" 
                            icon="ImageIcon" 
                            label="Images" 
                            title="Paramètres - Images"
                            required-plan="params_images"
                        />
                        <item 
                            v-if="isASuperAdmin() || isAnAdmin()" 
                            href="/rh/referentiel/parametres/graphisme" 
                            icon="ApertureIcon" 
                            label="Graphisme" 
                            title="Paramètres - Graphisme"
                            required-plan="params_graphics"
                        />
                        <item 
                            v-if="isASuperAdmin() || isAnAdmin()" 
                            href="/rh/referentiel/parametres/imports" 
                            icon="ApertureIcon" 
                            label="Imports" 
                            title="Paramètres - Imports"
                            required-plan="params_imports"
                        />
                        <item 
                            v-if="isASuperAdmin()" 
                            href="/rh/referentiel/parametres/exports" 
                            icon="DownloadIcon" 
                            label="Exports" 
                            title="Paramètres - Exports"
                            required-plan="params_exports"
                        />
                        <item 
                            v-if="can('read', 'trainings') && !shouldHideOptions()"
                            href="/rh/referentiel/parametres/trainings" 
                            icon="FileIcon" 
                            label="Ressources" 
                            title="Paramètres - Ressources" 
                            required-plan="params_resources"
                        />
                        <item
                            v-if="(isASuperAdmin() || isAnAdmin()) && planAllow('campaigns', null, false)"
                            href="/rh/referentiel/parametres/campaigns"
                            icon="TagIcon"
                            label="Sondages"
                            title="Paramètres - Sondages"
                            required-plan="params_campaigns"
                        />
                    </app-menu-group>

                    <span class="navigation-header truncate" v-if="isASuperAdmin() || isAnAdmin() || isADrh()">Archives</span>
                    <vs-sidebar-item v-if="isASuperAdmin() || isAnAdmin() || isADrh()" href="/rh/gestion/personnes/archives" ref="sidebarLink" index="/rh/gestion/personnes/archives" title="Liste des archivés">
                        <feather-icon icon="UserXIcon" class="" />
                        <span class="truncate">Archivés</span>
                    </vs-sidebar-item>

                    <!-- MOBILITE -->
                    <!-- <span class="navigation-header truncate">Mobilité</span>

                    <vs-sidebar-item href="/rh/mobilite/annonces" ref="sidebarLink" index="/rh/mobilite/annonces">
                        <feather-icon icon="UserCheckIcon" class="" />
                        <span class="truncate">Annonces</span>
                    </vs-sidebar-item>

                    <vs-sidebar-item href="/rh/mobilite/demandes" ref="sidebarLink" index="/rh/mobilite/demandes">
                        <feather-icon icon="TruckIcon" class="" />
                        <span class="truncate">Demandes</span>
                    </vs-sidebar-item>

                    <vs-sidebar-item href="/rh/mobilite/liste-attente" ref="sidebarLink" index="/rh/mobilite/liste-attente">
                        <feather-icon icon="ListIcon" class="" />
                        <span class="truncate">Liste d'attente</span>
                    </vs-sidebar-item>

                    <vs-sidebar-item href="/rh/mobilite/tableau-de-bord-candidats" ref="sidebarLink" index="/rh/mobilite/tableau-de-bord-candidats">
                        <feather-icon icon="BarChart2Icon" class="" />
                        <span class="truncate">Tableau de bord candidats</span>
                    </vs-sidebar-item> -->

                </div>
            </div>

        </vs-sidebar>
    </div>

</template>

<script>
import CrownIcon from '@components/svg/CrownIcon';


export default {
    name: "Menu",
    components: { CrownIcon },
    props: {
        menuLogo: {
            type: String,
            default: 'logo-dark'
        },
    },
    data() {
        return {
            isSidebarActive: true,
            currentIndex: null,
            group: {
                manageDashboard: {
                    index: 1,
                    name: "Tableau de bord",
                    icon: "PieChartIcon",
                    submenu: [{}, {}]
                }
            }
        }
    },
    computed: {

    },

    methods: {

    },

    mounted() {
        console.log('Logo Mounted', this.menuLogo)
    },
    created() {
        this.currentIndex = document.location.pathname;
        console.log('Logo Created', this.menuLogo)
    }
}
</script>

<style lang="scss">
    @import '../../../sass/vuesax/components/vxSidebar.scss';
</style>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  position: absolute;
  background-color: #f8f8f8;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 3;
  border-radius: 5px;
}

.dropmenu:hover{
  color: rgb(151, 47, 95);
  cursor: pointer;
}

.vs-sidebar--item:last-child {
    margin-bottom: 30px;
}
</style>

<style lang="scss" scoped>
#btnSidebarToggler {
  color: rgb(151, 47, 95);
  padding-left: 5px;
  margin-top: 0;
  margin-bottom: 0;
  &.active {
    circle {
      fill:rgb(151, 47, 95);
    }
  }
}
#btnSidebarToggler + .vs-sidebar--item {
  margin-top: 2rem;
}


</style>

<style>

@media screen and (max-width: 1200px) {
    .header-sidebar .truncate,
    .vs-sidebar--item .truncate,
    .vs-sidebar-group .truncate {
        display: none !important;
    }

    .main-menu-sidebar .vs-sidebar {
        max-width: 80px;
    }

    .vs-sidebar--item i.material-icons {
        margin-right: 0;
    }
    .main-menu-sidebar .feather-icon {
        margin-right: 0px;
    }
    .main-menu-sidebar .scroll-container .scroll-area--main-sidebar > .vs-sidebar--item {
        padding: 0 9px;
    }
    .main-menu-sidebar .scroll-container .scroll-area--main-sidebar > .vs-sidebar-group {
        padding: 0 4px;
    }

    .main-menu-sidebar .scroll-container .scroll-area--main-sidebar .vs-sidebar-group-items {
        margin-left: 5px;
    }
}

</style>
